import { Component } from 'react';
import { observer, inject } from 'mobx-react';
import i18n from 'i18next';
import * as React from 'react';
import { Box, Checkbox, FormControlLabel, Grid, Dialog, IconButton, Button, AppBar, Slide } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import api from '../../api';

import HeaderYokohama from '../common/HeaderYokohama';
import FooterYokohama from '../common/FooterYokohama';
import PickupWaitTime from '../common/PickupWaitTime';

import notice_down_arrow from '../../static/yokohama/images/notice_down_arrow.png';
import notice_step2_img from '../../static/yokohama/images/notice_step2_img.png';

import TopDelivery1 from '../../static/yokohama/images/TopDelivery_1.png';
import TopDelivery1_2 from '../../static/yokohama/images/TopDelivery_1_2.png';
import TopDelivery2 from '../../static/yokohama/images/TopDelivery_2.png';
import TopDelivery3 from '../../static/yokohama/images/TopDelivery_3.png';
import TopDelivery4 from '../../static/yokohama/images/TopDelivery_4.png';
import TopDelivery5 from '../../static/yokohama/images/TopDelivery_5.png';

@inject('commonStore', 'userStore')
@observer
class TopBayDiamond extends Component {
  state = {
    topPageImageUrl: '',
    dialogIsOpen: false,
  };

  async componentDidMount() {
    const { match, userStore } = this.props;
    await userStore.setUserDataFromLocalStorage();

    if (Object.keys(match.params).length > 0) {
      userStore.userData.zone = match.params.zone.toUpperCase();
      userStore.userData.block = match.params.block;
      userStore.userData.seat = match.params.seat;

      userStore.saveUserData();
    }

    const _consentToPrivacy = sessionStorage.getItem('consentToPrivacy');
    if (_consentToPrivacy) this.props.commonStore.consentToPrivacy = _consentToPrivacy === 'true' ? true : false;

    // CMS 에서 설정한 이미지
    const imageName = await api.getTopPageImage(this.props.userStore.userData.deliveryType);
    this.setState({
      topPageImageUrl:
        imageName.data === ''
          ? ''
          : `${window.location.protocol}//${window.location.hostname}${
              window.location.port ? ':' + window.location.port : ''
            }/CMSImage/${imageName.data}`,
      dialogIsOpen: imageName.data === '' ? false : true,
    });
  }

  handleOnChecked = e => {
    // 개인정보 제공 동의
    sessionStorage.setItem('consentToPrivacy', e.target.checked);
    this.props.commonStore.consentToPrivacy = e.target.checked;
  };

  Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  goToMain = () => {
    const { commonStore, history } = this.props;
    // 개인정보 제공에 동의 해야만 다음으로 진행 가능
    if (commonStore.consentToPrivacy) {
      history.push(`/${commonStore.companyId}/${commonStore.storeCode}`);
    } else {
      commonStore.setSnackbar(true, i18n.t('ERROR_PRIVARY_AGREEMENT'));
    }
  };

  render() {
    const { commonStore } = this.props;
    return (
      <React.Fragment>
        <AppBar position="fixed" color="header" style={{ boxShadow: 'none', zIndex: 1 }}>
          <HeaderYokohama />
        </AppBar>
        <Box className="notice-base" style={{ marginTop: '63px', backgroundColor: '#F2F2F2' }}>
          <PickupWaitTime />

          <Grid className="notice-base" style={{ padding: '20px', paddingTop: '50px' }}>
            {/** 모바일오더 안내 */}
            <Grid style={{ backgroundColor: '#FFF', borderRadius: '16px', padding: '40px', textAlign: 'center' }}>
              <div style={{ textAlign: 'center', display: 'inline-block' }}>
                <div
                  className="notice-step-font"
                  style={{
                    borderBottom: 'solid 2px #167BF1',
                    width: '120px',
                    paddingBottom: '7px',
                  }}
                >
                  About
                </div>
              </div>
              <div style={{ fontWeight: 'bold', fontSize: '20px', paddingTop: '10px' }}>
                HaMaMo!
                <br />
                ベイダイヤモンド・シートって何？
              </div>

              <div style={{ marginTop: '20px', textAlign: 'center' }}>
                <img src={TopDelivery1} style={{ width: '230px' }} alt="" />
              </div>

              <div style={{ fontSize: '16px', paddingTop: '15px' }}>
                HaMaMo! ベイダイヤモンド・シートは、ベイダイヤモンド・シート専用モバイルオーダーサービスです。
                スマホでオーダーして、座席で待つだけの便利なオーダーシステムです
              </div>
              <div style={{ fontSize: '16px', paddingTop: '15px' }}>
                座席に掲載しているQRコードを読み取ることで、すぐに利用いただけます。
              </div>
              <div style={{ paddingTop: '20px' }}>
                <img src={TopDelivery1_2} alt="" />
              </div>
            </Grid>
          </Grid>

          <Grid
            className="notice-base fonts-noto-sans-jp"
            style={{ textAlign: 'center', paddingTop: '20px', paddingLeft: '20px', paddingRight: '20px' }}
          >
            <div>
              <FormControlLabel
                onChange={this.handleOnChecked}
                control={<Checkbox checked={this.props.commonStore.consentToPrivacy} />}
                label={
                  <div>
                    <a href="https://www.yokohama-stadium.co.jp/mobileorder/term" target="_blank" rel="noreferrer">
                      サービス利用規約
                    </a>
                    <span>および</span>
                    <a href="https://www.yokohama-stadium.co.jp/privacy" target="_blank" rel="noreferrer">
                      プライバシーポリシー
                    </a>
                    に同意して
                  </div>
                }
              />
            </div>
            <div style={{ marginTop: '10px' }}>
              <Button
                onClick={this.goToMain}
                variant="contained"
                color="primary"
                style={{
                  width: '295px',
                  borderRadius: '24px',
                  height: '48px',
                  fontWeight: 'bold',
                  fontSize: '18px',
                }}
              >
                {i18n.t('BUTTON_ORDER_2')}
              </Button>
            </div>
          </Grid>

          <Grid className="notice-base" style={{ padding: '20px', paddingTop: '50px' }}>
            {/** 모바일오더 ACCOUNT */}
            <Grid style={{ backgroundColor: '#FFF', borderRadius: '16px', padding: '40px', textAlign: 'center' }}>
              <div style={{ textAlign: 'center', display: 'inline-block' }}>
                <div
                  className="notice-step-font"
                  style={{
                    borderBottom: 'solid 2px #167BF1',
                    width: '120px',
                    paddingBottom: '7px',
                  }}
                >
                  Account
                </div>
              </div>
              <div style={{ fontWeight: 'bold', fontSize: '20px', paddingTop: '10px' }}>DeNAアカウントについて</div>

              <div style={{ fontSize: '16px', paddingTop: '15px' }}>
                DeNAアカウントでログインすると、電話番号、通知用メールアドレスに、アカウントに登録されている情報が自動で入力されます
              </div>

              <div style={{ fontWeight: 'bold', fontSize: '20px', paddingTop: '20px' }}>DeNA Pay について</div>

              <div style={{ fontSize: '16px', paddingTop: '15px' }}>
                DeNAアカウントでログインすると、DeNA Pay でのお支払いが可能になります
              </div>

              <div style={{ fontWeight: 'bold', fontSize: '20px', paddingTop: '20px' }}>BlueMates会員の方</div>

              <div style={{ fontSize: '16px', paddingTop: '15px' }}>
                BlueMates会員の方は、ログインして1000円以上の金額でご注文いただくことで、STARを獲得できます。DeNAアカウントでログインしてご利用ください
                <br />※ BAYSTARS IDの手動入力連携機能はありません
              </div>

              <div style={{ fontSize: '16px', paddingTop: '15px', fontWeight: 'bold' }}>
                <a
                  href="https://support.accounts.dena.com/hc/ja/articles/34197857149721"
                  target="_blank"
                  rel="noreferrer"
                >
                  DeNAアカウントについて
                </a>
                <br />
                <a
                  href="https://support.accounts.dena.com/hc/ja/articles/31802544963609"
                  target="_blank"
                  rel="noreferrer"
                >
                  DeNA Pay について
                </a>
              </div>
            </Grid>
          </Grid>

          {/** 사용방법 */}
          <Grid
            className="notice-base"
            style={{
              textAlign: 'center',
              padding: '20px',
              paddingBottom: '40px',
              marginTop: '40px',

              background: '#f4ecdc',
              flex: 'none',
              order: 0,
              flexGrow: 0,
            }}
          >
            <div style={{ textAlign: 'center', display: 'inline-block' }}>
              <div
                className="notice-step-font"
                style={{
                  borderBottom: 'solid 2px #167BF1',
                  width: '120px',
                  paddingBottom: '7px',
                }}
              >
                How to use
              </div>
            </div>
            <div style={{ fontSize: '20px', paddingTop: '10px', paddingBottom: '40px', fontWeight: 'bold' }}>
              HaMaMo! ベイダイヤモンド・シートの使い方
            </div>

            <Grid style={{ backgroundColor: '#FFF', borderRadius: '16px', padding: '40px', textAlign: 'center' }}>
              <div className="notice-step-font" style={{ textAlign: 'left' }}>
                STEP 1
              </div>
              <div style={{ padding: '10px', fontSize: '18px', fontWeight: 'bold' }}>
                座席のQRコードから
                <br />
                注文サイトへアクセス
              </div>
              <div style={{ padding: '5px' }}>
                <img src={TopDelivery2} alt="" style={{ width: '275px' }} />
              </div>
              <div style={{ fontSize: '16px', color: '#000', textAlign: 'left' }}>
                座席のQRコードから注文サイトへアクセスし、商品を選択して、カートに入れます
              </div>
            </Grid>

            <div style={{ padding: '20px' }}>
              <img src={notice_down_arrow} width="44" alt="" />
            </div>

            <Grid style={{ backgroundColor: '#FFF', borderRadius: '16px', padding: '40px', textAlign: 'center' }}>
              <div className="notice-step-font" style={{ textAlign: 'left' }}>
                STEP 2
              </div>
              <div style={{ padding: '10px', fontSize: '18px', fontWeight: 'bold' }}>
                座席情報・メールアドレス・電話番号を
                <br />
                登録して、決済！
              </div>
              <div style={{ paddingTop: '0px', paddingBottom: '0px' }}>
                <img src={TopDelivery3} width="250" alt="" />
              </div>
              <div style={{ fontSize: '16px', textAlign: 'left' }}>
                座席情報、通知用メールアドレス、電話番号を入力し、決済方法を選んで購入します
              </div>
              <div style={{ fontSize: '16px', textAlign: 'left' }}>
                ※座席情報は座席のQRコードからアクセスした場合、自動で入力されております。誤りがないか確認し、誤りがある場合は手動で修正をお願いします
                <br />
                ※DeNAアカウントでログインしていただくことで、電話番号・メールアドレスは、DeNAアカウントの会員情報が自動で入力されます
              </div>
            </Grid>

            <div style={{ padding: '20px' }}>
              <img src={notice_down_arrow} width="44" alt="" />
            </div>

            <Grid style={{ backgroundColor: '#FFF', borderRadius: '16px', padding: '40px', textAlign: 'center' }}>
              <div className="notice-step-font" style={{ textAlign: 'left' }}>
                STEP 3
              </div>
              <div style={{ padding: '10px', fontSize: '18px', fontWeight: 'bold' }}>
                完成通知を受信したら座席で
                <br />
                商品を受け取りましょう！
              </div>
              <div style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                <img src={TopDelivery4} width="250" alt="" />
              </div>
              <div style={{ fontSize: '16px', textAlign: 'left' }}>
                完成通知が来たら、商品をお席にお持ちいたします。受取番号を見せて、注文内容を確認のうえ、お受け取りください！
              </div>
            </Grid>
          </Grid>

          <Grid className="notice-base fonts-noto-sans-jp" style={{ textAlign: 'center', paddingTop: '40px' }}>
            <div style={{ padding: '20px' }}>
              <FormControlLabel
                onChange={this.handleOnChecked}
                control={<Checkbox checked={this.props.commonStore.consentToPrivacy} />}
                label={
                  <div>
                    <a href="https://www.yokohama-stadium.co.jp/mobileorder/term" target="_blank" rel="noreferrer">
                      サービス利用規約
                    </a>
                    <span>および</span>
                    <a href="https://www.yokohama-stadium.co.jp/privacy" target="_blank" rel="noreferrer">
                      プライバシーポリシー
                    </a>
                    に同意して
                  </div>
                }
              />
            </div>
            <div style={{ marginTop: '10px' }}>
              <Button
                onClick={this.goToMain}
                variant="contained"
                style={{
                  width: '295px',
                  borderRadius: '24px',
                  height: '48px',
                  fontWeight: 'bold',
                  fontSize: '18px',
                }}
              >
                {i18n.t('BUTTON_ORDER_2')}
              </Button>
            </div>
          </Grid>

          {/** 결제종류 안내 */}
          <Grid style={{ marginTop: '64px', backgroundColor: '#FFF', padding: '40px' }}>
            <div style={{ textAlign: 'center', display: 'inline-block' }}>
              <div
                className="notice-step-font"
                style={{
                  borderBottom: 'solid 2px #167BF1',
                  width: '120px',
                  paddingBottom: '7px',
                }}
              >
                Settlement
              </div>
            </div>
            <div
              style={{
                fontSize: '20px',
                paddingTop: '10px',
                paddingBottom: '40px',
                fontWeight: 'bold',
              }}
            >
              決済方法
            </div>

            <div style={{ fontSize: '16px', color: '#000', textAlign: 'left' }}>
              HaMaMo! ベイダイヤモンド・シートでは、キャッシュレスでの決済になります。以下の方法で決済が可能です。
              <br />
              ※DeNA Payでお支払いいただくには、DeNAアカウントにログインしていただく必要があります
            </div>

            <div style={{ paddingTop: '40px' }}>
              <img src={notice_step2_img} width="250" alt="" />
            </div>

            {/* <div style={{ paddingTop: '70px' }}>
              <a
                href={process.env.REACT_APP_SURVEY_URL}
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: 'none' }}
              >
                利用者アンケート
                <br />
                ご回答にご協力ください
              </a>
            </div> */}
          </Grid>

          {/**주의사항 */}
          <Grid style={{ padding: '40px', textAlign: 'left' }}>
            <Grid style={{ paddingTop: '30px' }}>【{i18n.t('MESSAGE_NOTES')}】</Grid>
            <Grid>
              <div
                dangerouslySetInnerHTML={{
                  __html: `${commonStore.noticeText.NOTICE}`,
                }}
              />
            </Grid>
          </Grid>

          <Grid
            container
            style={{
              marginTop: '40px',
              paddingLeft: '20.5px',
              paddingRight: '20.5px',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <img
              src={TopDelivery5}
              width="335"
              style={{ margin: '0px', padding: '0px', marginBottom: '-23px' }}
              alt=""
            />
          </Grid>

          <FooterYokohama />
        </Box>

        <Dialog
          maxWidth="xl"
          fullWidth={true}
          open={this.state.dialogIsOpen}
          onClose={x => this.setState({ ...x, dialogIsOpen: false })}
        >
          <div style={{ position: 'absolute', right: '0px' }}>
            <IconButton
              aria-label="close"
              onClick={x => this.setState({ ...this.state, dialogIsOpen: !this.state.dialogIsOpen })}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <img
            src={this.state.topPageImageUrl}
            alt=""
            style={{ width: '100%', padding: '0px', margin: '0px', border: '0' }}
          />
        </Dialog>
      </React.Fragment>
    );
  }
}
export default TopBayDiamond;
